/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Internal_CodeInputs */

const vi_order_internal_code = /** @type {(inputs: Order_Internal_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn nội bộ`)
};

/**

* @param {Order_Internal_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_internal_code = /** @type {((inputs?: Order_Internal_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Internal_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_internal_code(inputs)
});